import { render, staticRenderFns } from "./promo-sale-reminder-modal-container.vue?vue&type=template&id=547f706d&"
import script from "./promo-sale-reminder-modal-container.vue?vue&type=script&lang=js&"
export * from "./promo-sale-reminder-modal-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports